import type {VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {menuItemVariants} from './menu-item-variants';

type MenuItemProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof menuItemVariants> & {
    active?: boolean;
  };

const MenuItem = React.forwardRef<HTMLButtonElement, MenuItemProps>(
  ({className, variant, active, ...props}, ref) => (
    <button
      ref={ref}
      className={cn(
        menuItemVariants({variant, active}),
        'cursor-pointer',
        className
      )}
      {...props}
    />
  )
);
MenuItem.displayName = 'MenuItem';

export {MenuItem};
